import React, { useContext, useState, useEffect } from 'react';
import { Button, Container, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import { Link } from 'react-router-dom';
import api from '../../connection/Axios';
import icoArrowDown from '../../assets/icoArrowDown.png'
import icoArrowUp from '../../assets/icoArrowUp.png'
import icoArrowRight from '../../assets/icoArrowRight.png'
import moment from 'moment-timezone';


const HistoricoDeVistorias = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [vistorias, setVistorias] = useState([])
  const [filterBy, setFilterBy] = useState('resolvido')
  const [sortBy, setSortBy] = useState(null)

  const sortData = (criteria) => {
    let sortedData;

    switch (criteria) {
      case 'dataHora': // Supondo que o campo de data seja chamado 'date'
        sortedData = [...vistorias].sort((a, b) => new Date(a.dataHora) - new Date(b.dataHora));
        break;
        case 'ID':
          sortedData = [...vistorias].sort((a, b) => a.id - b.id);
          break;
        case 'Status':
          sortedData = [...vistorias].sort((a, b) => a.status.localeCompare(b.status));
          break;
        case 'empreend':
          sortedData = [...vistorias].sort((a, b) => a.empreend.localeCompare(b.empreend));
          break;
      default:
        return;
    }

    setVistorias(sortedData);
    setSortBy(criteria);
  };


  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};
    
    const data = {
      company: userData?.role === 'cliente' || userData.role === 'clienteAdm' ? userData?.companyId : null
    }
  
    async function GetServices() {
      api.post('vistoria/getServices', data, headers).then(response => {
        setVistorias(response.data)
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
    
    useEffect(()=>{
      GetServices()
    }, [])

    console.log(vistorias)

    const Box = (props) => {

      const StatusColor = () => {
        switch (props.data.status) {
            case 'pendente' : return <div style={{backgroundColor: '#ff8536', color: '#ffffff'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;{props.data.status}</b></div>
            case 'atencao' : return <div style={{backgroundColor: '#aa0000', color: '#ffffff'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;{props.data.status}</b></div>
            case 'resolvido' : return <div style={{borderColor: '#494949', color: '#494949'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;{props.data.status}</b></div>
            default : return '#000000' 
        }
    }

      return(
        <>
        
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', flex: 1}}>
            <div style={styles.vistoria}>
            <div style={{width: 200}}>
                <div style={{color: '#ed6e2d', fontSize: 13, fontWeight: 600, marginRight: 15}}>{props.data.id}</div>
                <div style={{color: '#000000', fontSize: 13, fontWeight: 600}}>{props.data.empreend}</div>
              </div>  
              
                <div style={{width: 250}}>
                  <div style={{fontWeight: 600, fontSize: 13}}></div>
                  <div style={{fontWeight: 600, fontSize: 13}}>Agenda: <span style={{color: '#ed6e2d',}}>{moment(props.data.dataHora).format('DD/MM/YYYY - HH:mm')}</span></div>
                </div>
                
                  <StatusColor />
                  <Button component={Link} to="/vistoria-detalhe" state={{data: props.data}} style={{backgroundColor: '#ffffff', paddingLeft:20, border: 'none'}}>
                    <img src={icoArrowRight} width='10' />
                  </Button>
                

            </div>
          </div>
        </>
      )
    }

  return (
    <>
        <Layout breadcrumb='Dashboard / Inspeções / Histórico de Inspeções' title='Histórico de Inspeções'>

          <div style={{display: 'flex', marginBottom: 20, alignItems: 'center'}}>
            Ordenar por: &nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{sortData('ID')}}>{sortBy === 'ID' ? <b>ID</b> : 'ID'}</Button>&nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{sortData('dataHora')}}>{sortBy === 'dataHora' ? <b>Agenda</b> : 'Agenda'}</Button>&nbsp;&nbsp;
            <Button variant='outlined' size='small' onClick={()=>{sortData('empreend')}}>{sortBy === 'empreend' ? <b>Nome</b> : 'Nome'}</Button>&nbsp;&nbsp;
          </div>
          <div style={{textTransform: 'capitalize'}}>
            Ordenado por: <b>{sortBy ? sortBy : 'Nenhum critério'}</b>
          </div>

          {vistorias.length != 0 ? vistorias.reverse().filter(filterBy != 'todos' ? vistoria => vistoria.status === filterBy : vistoria => vistoria.status === 'novo' || vistoria.status === 'iniciado' || vistoria.status === 'vistoriado' || vistoria.status === 'revisar' || vistoria.status === 'vistoriado').map((vistoria, index)=>(
              <Box data={vistoria} key={index} />
            )) : null}


        </Layout>
    </>
  );
};

export default HistoricoDeVistorias

const styles = {
  vistoria: {
      backgroundColor: '#FFFFFF',
      padding: 20,
      borderRadius: 12,
      marginBlock: 10,
      display: 'flex',
      color: '#000000',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%'
  },
  vistoria2: {
      backgroundColor: '#002638',
      padding: 20,
      borderRadius: 12,
      marginBlock: 20,
      display: 'flex',
      color: '#ffffff',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
      fontSize: 15
  },
  setaOn: {
    
  },
  setaOff: {
    transform: [{rotateX: 180}],

  }
}